var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpinionsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84339 3.63344C10.1827 4.14118 10.1827 4.848 10.1827 6.26165C10.1827 7.67529 10.1827 8.38211 9.84339 8.88985C9.69652 9.10966 9.5078 9.29839 9.28799 9.44526C8.84443 9.74163 8.24895 9.7791 7.16305 9.78384V9.78452L6.60665 10.8973C6.42118 11.2683 5.89184 11.2683 5.70638 10.8973L5.14998 9.78452V9.78384C4.06408 9.7791 3.4686 9.74163 3.02504 9.44526C2.80523 9.29839 2.61651 9.10966 2.46963 8.88985C2.13037 8.38211 2.13037 7.67529 2.13037 6.26165C2.13037 4.848 2.13037 4.14118 2.46963 3.63344C2.61651 3.41363 2.80523 3.2249 3.02504 3.07803C3.53278 2.73877 4.2396 2.73877 5.65325 2.73877H6.65978C8.07342 2.73877 8.78024 2.73877 9.28799 3.07803C9.5078 3.2249 9.69652 3.41363 9.84339 3.63344Z",
    stroke: "#B0A199",
    strokeWidth: 0.862745,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64648 5.25488L7.66609 5.25488",
    stroke: "#B0A199",
    strokeWidth: 0.862745,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64648 7.26807H6.15629",
    stroke: "#B0A199",
    strokeWidth: 0.862745,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpinionsIcon);
export default __webpack_public_path__ + "static/media/Opinions_Icon.79e26b03a6cab162bf20a17a3f0b27f1.svg";
export { ForwardRef as ReactComponent };